"use client";

import React, { useEffect, useState } from "react";
import "swiper/css";
import Banner from "./Banner";
import { HomeBanner } from "@/packages/types/banner";
import { fetchAllAdditionalBanners } from "@/api-service/banner";

type SlidersProps = {
  className?: string;
};
const AdditionalSlider: React.FC<SlidersProps> = ({ className }) => {
  const [banners, setBanners] = useState<HomeBanner[]>([]);

  useEffect(() => {
    const loadBanners = async () => {
      try {
        const res = await fetchAllAdditionalBanners();

        setBanners(res || []);
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    loadBanners();
  }, []);
  return (
    <div className={`max-w-7xl mx-auto mb-5 px-4 md:px-6 lg:px-8 ${className}`}>
      {/* children */}
      {/* Left Side Banner */}
      <div className="w-full">
        <Banner banners={banners} />
      </div>
    </div>
  );
};

export default AdditionalSlider;
